export default "__VITE_ASSET__2dca728e__"